import { useTranslation } from "react-i18next";
import { ExclamationIcon } from "@heroicons/react/outline";
import Spinner from "../../../common/components/Loader/Spinner";

export const hasWidthUtility = (className: string) => /(^|\s)(w-|min-w-)/.test(className);

export const MediaLoadingCard = ({
  className = "",
  error = false,
  onRetry,
}: {
  className?: string;
  error?: boolean;
  onRetry?: () => void;
}) => {
  const { t } = useTranslation();
  const defaultBox = hasWidthUtility(className) ? "" : "w-[244px] sm:w-[357px] max-w-full";
  return (
    <div
      className={`${className} ${defaultBox} rounded-xl flex relative bg-white overflow-hidden shadow-md image-card`}
      data-testid="media-loading-card"
    >
      <div className="w-full h-full">
        <div className="p-2 flex items-center justify-center w-full h-32 sm:h-48">
          <div className="relative bg-gray-100 w-full h-full flex flex-col items-center justify-center gap-2 rounded-xl overflow-hidden">
            {error ? (
              <>
                <ExclamationIcon className="h-6 w-6 text-slate-400" aria-hidden="true" />
                <span className="text-sm text-slate-600">
                  {t("pages.gallery.previewUnavailable")}
                </span>
                {onRetry && (
                  <button
                    type="button"
                    className="text-sm font-medium text-green-800 hover:text-green-900 rounded-md px-1 focus:outline-none focus-visible:ring-2 focus-visible:ring-green-500"
                    onClick={(event) => {
                      event.stopPropagation();
                      onRetry();
                    }}
                  >
                    {t("pages.gallery.retryPreview")}
                  </button>
                )}
              </>
            ) : (
              <Spinner />
            )}
          </div>
        </div>
        <div className="block mt-1 mb-3 mx-4">
          <div className="flex justify-between w-full">
            <h3 className="text-black text-sm text-left">&nbsp;</h3>
            <div className="h-6 w-6" />
          </div>
          <div className="flex justify-between">
            <span className="text-xs text-gray-500">&nbsp;</span>
          </div>
        </div>
      </div>
    </div>
  );
};
